import { render, staticRenderFns } from "./MarketGroupConfig.vue?vue&type=template&id=76ab9eba&scoped=true&"
import script from "./MarketGroupConfig.vue?vue&type=script&lang=js&"
export * from "./MarketGroupConfig.vue?vue&type=script&lang=js&"
import style0 from "./MarketGroupConfig.vue?vue&type=style&index=0&id=76ab9eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ab9eba",
  null
  
)

export default component.exports